import { makeBroadcastChannel } from '@solid-primitives/broadcast-channel'
import { makeConnectivityListener } from '@solid-primitives/connectivity'
import { type Component, createContext, createSignal, type JSX, onCleanup, onMount, useContext } from 'solid-js'
import { useSettings } from '~/stores/settings'

interface ThemeContextValue {
  isDark: () => boolean
  toggleTheme: () => void
  isOnline: () => boolean
  // optional provider for icon imports (import.meta.glob results)
  icons?: () => Record<string, unknown> | undefined
}

export const ThemeContext = createContext<ThemeContextValue>()
export const ThemeProvider: Component<{ children: JSX.Element; icons?: Record<string, unknown> }> = props => {
  const { settings, updateTheme } = useSettings()
  const { postMessage, onMessage } = makeBroadcastChannel('theme-updates')
  const isDark = () => settings.theme === 'dark'
  const toggleTheme = () => {
    const n = isDark() ? 'light' : 'dark'
    updateTheme(n)
    postMessage(n)
  }
  const [isOnline, setIsOnline] = createSignal(true)
  const clear = makeConnectivityListener(isOnline => {
    console.log('isOnline', isOnline)
    setIsOnline(isOnline)
  })

  onMessage(({ data }) => {
    updateTheme(data as 'light' | 'dark')
  })
  onMount(() => {
    updateTheme(settings.theme)
  })

  onCleanup(() => {
    clear() // Limpia el listener de conectividad al desmontar el componente
  })

  return <ThemeContext.Provider value={{ isDark, toggleTheme, isOnline, icons: () => props.icons }}>{props.children}</ThemeContext.Provider>
}

export const useAppState = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useAppState must be used within a ThemeProvider')
  }
  return context
}
